import {UserApplication} from './user.model';
export class LoggedInUser {
  public id: number;
  public token: string;
  public tokenExpiresAt: number;
  public tokenExpireDate: Date;
  public tokenMinuteLimit: number;
  public refreshToken: string;
  public login: string;
  public role: string;
  public selectedCompany: number;
  public companies: LoggedInUserCompany[];
  public firstName: string;
  public lastName: string;
  public accountLock: boolean;
  public enabledApplications: number[];   //FIXME: remove enabledApplications and use enabledUserApps instead
  public enabledUserApps: UserApplication[];
  public language: string;
}

export class LoggedInUserCompany {
  public id: number;
  public descr: string;

  constructor(_id, _descr) {
    this.id = _id;
    this.descr = _descr;
  }
}

export class SessionData {
  public selectedLanguage: string;
}



// WEBPACK FOOTER //
// ./src/app/models/loggedinuser.model.ts